import StylesType from './Styles';
import { BookingSettings } from './booking';
import { WorkTimeType } from './main';

export enum PlaceChainTypeEnum {
	ChainBranch = 'CHAIN_BRANCH',
	ChainMain = 'CHAIN_MAIN',
	Simple = 'SIMPLE',
}

type PlaceType = {
	placeType: PlaceChainTypeEnum;
	name: string;
	styles: StylesType;
	workTime: WorkTimeType[];
	opened: boolean;
	active: boolean;
	contactInfo: {
		address: PlaceAddressType;
		phone?: string;
	};
	customize: {
		hideRequestCustomerVAT?: boolean;
	};
	companyImages: {
		mobile?: string;
		desktop?: string;
		logo?: string;
		pwaLogo?: string;
	};
	marketing?: LocationMarketingType;
	reservation: BookingSettings;
	domain?: string;
};

export type LocationMarketingType = {
	analytics?: LocationAnalyticsType;
};

export type LocationAnalyticsType = {
	gtm?: string;
	fbPixel?: string;
	ga?: string;
	fbDomainVerification?: string;
};

export enum LocationPointTypeEnum {
	area = 'area',
	point = 'point',
}

export type PlaceAddressType = {
	useCustomMap?: boolean;
	prediction: string;
	location: {
		coordinates: [number, number];
		type: LocationPointTypeEnum;
	};
	countryCode: string;
	city: string;
	country: string;
	postalCode: string;
	sublocality: string;
};

export default PlaceType;
